/* Patiluz — interacciones propias (prefijo lp-). Sin librerías. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function onVisible(el, cb, opts) {
    if (!('IntersectionObserver' in window)) { cb(el); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { cb(e.target); io.unobserve(e.target); }
      });
    }, opts || { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    io.observe(el);
  }

  /* ---------- Titulares que entran palabra a palabra ---------- */
  function initSplit(root) {
    root.querySelectorAll('[data-lp-split]:not(.lp-split)').forEach(function (el) {
      var i = 0;
      function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var w = document.createElement('span'); w.className = 'lp-w';
              var inner = document.createElement('span'); inner.textContent = part;
              inner.style.setProperty('--i', i++);
              w.appendChild(inner); frag.appendChild(w);
            });
            child.parentNode.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') {
            if (child.classList.contains('lp-lit')) {
              /* Palabra iluminada: se envuelve entera para mantener el degradado */
              var w2 = document.createElement('span'); w2.className = 'lp-w';
              child.parentNode.insertBefore(w2, child);
              var wrap = document.createElement('span'); wrap.style.setProperty('--i', i++);
              w2.appendChild(wrap); wrap.appendChild(child);
            } else { walk(child); }
          }
        });
      }
      walk(el);
      el.classList.add('lp-split');
      onVisible(el, function (t) { t.classList.add('lp-in'); });
    });
  }

  /* ---------- Reveal al hacer scroll ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('[data-lp-reveal]:not(.lp-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('lp-in'); }); return; }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('lp-in'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Texto que se ilumina palabra a palabra al hacer scroll ---------- */
  var litEls = [];
  function initScrollLit(root) {
    root.querySelectorAll('[data-lp-scrolllit]:not([data-lp-on])').forEach(function (el) {
      el.setAttribute('data-lp-on', '1');
      var words = [];
      function walk(node, key) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var w = document.createElement('span');
              w.className = 'lp-mw' + (key ? ' lp-mw--key' : '');
              w.textContent = part; words.push(w); frag.appendChild(w);
            });
            child.parentNode.replaceChild(frag, child);
          } else if (child.nodeType === 1) {
            walk(child, key || child.classList.contains('lp-manif__key'));
          }
        });
      }
      walk(el, false);
      if (reduce) { words.forEach(function (w) { w.classList.add('is-lit'); }); return; }
      litEls.push({ el: el, words: words });
    });
  }
  function litFrame() {
    var vh = window.innerHeight;
    litEls.forEach(function (o) {
      var r = o.el.getBoundingClientRect();
      /* empieza a encenderse al entrar por abajo y termina a media pantalla */
      var p = (vh * 0.9 - r.top) / (vh * 0.9 - vh * 0.4 + r.height * 0.5);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * o.words.length);
      o.words.forEach(function (w, i) { w.classList.toggle('is-lit', i < n); });
    });
  }

  /* ---------- Parallax suave (solo transform) ---------- */
  var parallaxEls = [];
  function initParallax(root) {
    root.querySelectorAll('[data-lp-parallax]').forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
  }
  var ticking = false;
  function parallaxFrame() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      if (!el.isConnected) return;
      var host = el.parentElement;
      var r = host.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var k = parseFloat(el.getAttribute('data-lp-parallax')) || 0;
      var progress = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.setProperty('--lp-par', (-progress * k).toFixed(1) + 'px');
    });
    litFrame();
    ticking = false;
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(parallaxFrame); } }

  /* ---------- Foco de luz que sigue al cursor en el hero ---------- */
  function initSpot(root) {
    root.querySelectorAll('.lp-hero').forEach(function (hero) {
      if (hero.dataset.lpSpot) return; hero.dataset.lpSpot = '1';
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--lp-mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        hero.style.setProperty('--lp-my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
  }

  /* ---------- Botones magnéticos y tarjetas con inclinación ---------- */
  function initMagnetic(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    root.querySelectorAll('[data-lp-magnetic]').forEach(function (b) {
      if (b.dataset.lpMag) return; b.dataset.lpMag = '1';
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18, y = (e.clientY - r.top - r.height / 2) * 0.3;
        b.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
    root.querySelectorAll('[data-lp-tilt]').forEach(function (c) {
      if (c.dataset.lpTiltOn) return; c.dataset.lpTiltOn = '1';
      var max = parseFloat(c.getAttribute('data-lp-tilt')) || 6;
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = 'perspective(900px) rotateY(' + (px * max) + 'deg) rotateX(' + (-py * max) + 'deg) translateY(-4px)';
      });
      c.addEventListener('pointerleave', function () { c.style.transform = ''; });
    });
  }

  /* ---------- Selector de colores ---------- */
  function initColores(root) {
    root.querySelectorAll('[data-lp-colores]').forEach(function (sec) {
      if (sec.dataset.lpOn) return; sec.dataset.lpOn = '1';
      var chips = sec.querySelectorAll('.lp-chip');
      var imgs = sec.querySelectorAll('.lp-colores__img');
      var name = sec.querySelector('.lp-colores__name');
      var count = sec.querySelector('[data-lp-count-current]');
      var link = sec.querySelector('[data-lp-color-link]');
      var timer = null, idx = 0;
      var auto = parseInt(sec.getAttribute('data-autoplay'), 10) || 0;
      function select(i, user) {
        idx = i;
        chips.forEach(function (c, j) { c.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
        var chip = chips[i]; if (!chip) return;
        sec.style.setProperty('--lp-c', chip.getAttribute('data-color'));
        if (name) name.textContent = chip.getAttribute('data-name');
        if (count) count.textContent = String(i + 1).padStart(2, '0');
        if (link && chip.getAttribute('data-url')) link.setAttribute('href', chip.getAttribute('data-url'));
        if (user) stop();
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      chips.forEach(function (c, i) { c.addEventListener('click', function () { select(i, true); }); });
      select(0);
      if (auto > 0 && !reduce && chips.length > 1) {
        onVisible(sec, function () {
          timer = setInterval(function () { select((idx + 1) % chips.length); }, auto * 1000);
        });
      }
    });
  }

  /* ---------- Modos de luz ---------- */
  function initModos(root) {
    root.querySelectorAll('[data-lp-modos]').forEach(function (sec) {
      if (sec.dataset.lpOn) return; sec.dataset.lpOn = '1';
      var stage = sec.querySelector('.lp-modos__stage');
      var btns = sec.querySelectorAll('.lp-modo');
      var cycle = parseFloat(sec.getAttribute('data-cycle')) || 4;
      var timer = null, idx = 0;
      sec.style.setProperty('--lp-cycle', cycle + 's');
      function select(i) {
        idx = i;
        btns.forEach(function (b, j) {
          b.classList.remove('is-active'); void b.offsetWidth;
          if (j === i) b.classList.add('is-active');
          b.setAttribute('aria-selected', j === i ? 'true' : 'false');
        });
        if (stage && btns[i]) stage.setAttribute('data-mode', btns[i].getAttribute('data-mode'));
      }
      function start() { stop(); timer = setInterval(function () { select((idx + 1) % btns.length); }, cycle * 1000); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { sec.classList.add('is-paused'); stop(); select(i); });
      });
      select(0);
      if (!reduce && btns.length > 1) onVisible(sec, start);
    });
  }

  /* ---------- Cifras animadas ---------- */
  function initCount(root) {
    root.querySelectorAll('[data-lp-count]').forEach(function (el) {
      if (el.dataset.lpOn) return; el.dataset.lpOn = '1';
      var target = parseFloat(el.getAttribute('data-lp-count'));
      if (isNaN(target) || reduce) return;
      el.textContent = '0';
      onVisible(el, function () {
        var t0 = null, dur = 1600;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 4);
          el.textContent = Math.round(target * e);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    });
  }

  /* ---------- Medidor de tallas ---------- */
  function initTallas(root) {
    root.querySelectorAll('[data-lp-tallas]').forEach(function (sec) {
      if (sec.dataset.lpOn) return; sec.dataset.lpOn = '1';
      var range = sec.querySelector('.lp-range');
      var val = sec.querySelector('.lp-medidor__val');
      var size = sec.querySelector('.lp-medidor__size');
      var msg = sec.querySelector('.lp-medidor__msg');
      var rows = sec.querySelectorAll('tr[data-min]');
      if (!range) return;
      function update() {
        var cm = parseFloat(range.value);
        var p = (cm - range.min) / (range.max - range.min) * 100;
        range.style.setProperty('--p', p + '%');
        val.textContent = cm + ' cm';
        var best = null;
        rows.forEach(function (r) {
          var mn = parseFloat(r.dataset.min), mx = parseFloat(r.dataset.max);
          var ok = cm >= mn && cm <= mx;
          if (ok && !best) best = r; /* la talla más pequeña que lo cubre */
          r.classList.remove('is-match');
        });
        if (best) {
          best.classList.add('is-match');
          size.textContent = best.dataset.size;
          var mx2 = parseFloat(best.dataset.max);
          msg.textContent = (mx2 - cm <= 1 && best.nextElementSibling)
            ? sec.dataset.msgBorde.replace('[talla]', best.dataset.size).replace('[siguiente]', best.nextElementSibling.dataset.size)
            : sec.dataset.msgOk.replace('[talla]', best.dataset.size);
        } else {
          size.textContent = '—';
          msg.textContent = sec.dataset.msgFuera;
        }
      }
      range.addEventListener('input', update);
      update();
    });
  }

  /* ---------- Botones que abren la guía de tallas ---------- */
  function initSizeLinks(root) {
    root.querySelectorAll('[data-lp-goto]').forEach(function (b) {
      if (b.dataset.lpOn) return; b.dataset.lpOn = '1';
      b.addEventListener('click', function () {
        var t = document.querySelector(b.getAttribute('data-lp-goto'));
        if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    root.querySelectorAll('[data-lp-pdp]').forEach(function (sec) {
      if (sec.dataset.lpOn) return; sec.dataset.lpOn = '1';
      var dataEl = sec.querySelector('[data-lp-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = sec.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceEl = sec.querySelector('[data-lp-price]');
      var compareEl = sec.querySelector('[data-lp-compare]');
      var badgeEl = sec.querySelector('[data-lp-badge]');
      var addBtn = sec.querySelector('[data-lp-add]');
      var addLabel = addBtn ? addBtn.querySelector('span') : null;
      var msg = sec.querySelector('.lp-buy__msg');
      var sticky = document.querySelector('[data-lp-sticky]');
      var stickyPrice = sticky ? sticky.querySelector('[data-lp-sticky-price]') : null;
      var stickyVar = sticky ? sticky.querySelector('[data-lp-sticky-variant]') : null;
      var money = sec.getAttribute('data-money') || '${{amount}}';
      var txtAdd = sec.getAttribute('data-txt-add'), txtSold = sec.getAttribute('data-txt-sold'),
          txtNA = sec.getAttribute('data-txt-na'), txtAdded = sec.getAttribute('data-txt-added'),
          txtAdding = sec.getAttribute('data-txt-adding'), txtError = sec.getAttribute('data-txt-error');

      function fmt(cents) {
        var m = money.match(/\{\{\s*(\w+)\s*\}\}/); var kind = m ? m[1] : 'amount';
        var v = (cents / 100);
        var parts;
        if (kind.indexOf('no_decimals') !== -1) { parts = [Math.round(v).toString(), '']; } else { parts = v.toFixed(2).split('.'); }
        var sep = kind.indexOf('comma_separator') !== -1 ? ['.', ','] : (kind.indexOf('apostrophe') !== -1 ? ["'", '.'] : [',', '.']);
        var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep[0]);
        var out = parts[1] ? int + sep[1] + parts[1] : int;
        return money.replace(/\{\{\s*\w+\s*\}\}/, out);
      }

      /* Galería */
      var mains = sec.querySelectorAll('.lp-gal__main img');
      var thumbs = sec.querySelectorAll('.lp-gal__thumb');
      var gIdx = 0;
      function show(i) {
        if (!mains.length) return;
        gIdx = (i + mains.length) % mains.length;
        mains.forEach(function (m, j) { m.classList.toggle('is-active', j === gIdx); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === gIdx); });
        var t = thumbs[gIdx]; if (t && t.parentElement) {
          var p = t.parentElement;
          if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
          else p.scrollTo({ top: t.offsetTop - p.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var preActive = -1;
      mains.forEach(function (m, j) { if (m.classList.contains('is-active')) preActive = j; });
      if (preActive === -1) show(0); else gIdx = preActive;
      var prev = sec.querySelector('[data-lp-prev]'), next = sec.querySelector('[data-lp-next]');
      if (prev) prev.addEventListener('click', function () { show(gIdx - 1); });
      if (next) next.addEventListener('click', function () { show(gIdx + 1); });
      var main = sec.querySelector('.lp-gal__main');
      if (main) {
        var sx = null;
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (sx === null) return; var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) show(gIdx + (dx < 0 ? 1 : -1)); sx = null;
        });
      }
      function mediaIndex(id) {
        for (var i = 0; i < mains.length; i++) { if (mains[i].getAttribute('data-media-id') === String(id)) return i; }
        return -1;
      }

      /* Variantes */
      var fieldsets = sec.querySelectorAll('.lp-opt[data-index]');
      function selected() {
        var vals = [];
        fieldsets.forEach(function (fs) {
          var c = fs.querySelector('input:checked'); vals[parseInt(fs.dataset.index, 10)] = c ? c.value : null;
        });
        return vals;
      }
      function findVariant(vals) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var k = 0; k < vals.length; k++) { if (v.options[k] !== vals[k]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function markAvailability(vals) {
        fieldsets.forEach(function (fs) {
          var k = parseInt(fs.dataset.index, 10);
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = vals.slice(); test[k] = inp.value;
            var v = findVariant(test);
            var lab = inp.nextElementSibling;
            if (lab) lab.classList.toggle('is-off', !v || !v.available);
          });
          var label = fs.querySelector('[data-lp-opt-label]'), c = fs.querySelector('input:checked');
          if (label && c) label.textContent = c.getAttribute('data-label') || c.value;
        });
      }
      function update(user) {
        var vals = selected();
        var v = findVariant(vals);
        markAvailability(vals);
        if (!v) {
          if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = txtNA; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (stickyPrice) stickyPrice.textContent = fmt(v.price);
        if (stickyVar) stickyVar.textContent = vals.map(function (x, i) {
          var inp = fieldsets[i] ? fieldsets[i].querySelector('input:checked') : null;
          return inp ? (inp.getAttribute('data-label') || x) : x;
        }).join(' · ');
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = fmt(v.compare_at_price); compareEl.hidden = false; if (badgeEl) badgeEl.hidden = false; }
          else { compareEl.hidden = true; if (badgeEl) badgeEl.hidden = true; }
        }
        if (addBtn) { addBtn.disabled = !v.available; if (addLabel) addLabel.textContent = v.available ? txtAdd : txtSold; }
        if (user && v.featured_media) { var mi = mediaIndex(v.featured_media.id); if (mi > -1) show(mi); }
        if (user && window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); }); });
      if (fieldsets.length) update(false);

      /* Cantidad */
      var qty = sec.querySelector('.lp-qty input');
      sec.querySelectorAll('[data-lp-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-lp-qty'), 10);
          qty.value = Math.max(1, n);
        });
      });

      /* Añadir al carrito sin salir de la página (y abrir el carrito de Dawn si existe) */
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = txtAdding; }
          var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          var fd = new FormData(form);
          if (cartEl && cartEl.getSectionsToRender) {
            fd.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
            if (cartEl.setActiveElement) cartEl.setActiveElement(document.activeElement);
          }
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) { if (msg) msg.textContent = res.description || res.message || txtError; return; }
            if (msg) msg.textContent = txtAdded;
            if (cartEl && cartEl.renderContents) {
              if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
              var d = cartEl.closest && cartEl.closest('.drawer'); if (d) d.classList.remove('is-empty');
              cartEl.renderContents(res);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          }).catch(function () { if (msg) msg.textContent = txtError; })
            .finally(function () { update(false); });
        });
      }

      /* Barra fija de compra en móvil */
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (x) { sticky.classList.toggle('is-on', !x.isIntersecting && x.boundingClientRect.top < 0); });
        });
        io.observe(addBtn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { if (addBtn && !addBtn.disabled) form.requestSubmit ? form.requestSubmit() : addBtn.click(); });
      }
    });
  }

  function initAll(root) {
    root = root || document;
    initSplit(root);
    initScrollLit(root);
    initReveal(root);
    initParallax(root);
    initSpot(root);
    initMagnetic(root);
    initColores(root);
    initModos(root);
    initCount(root);
    initTallas(root);
    initSizeLinks(root);
    initProducto(root);
    if (!reduce) parallaxFrame();
  }

  window.lpReady = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  if (!reduce) { window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); }

  /* Editor de Shopify: re-inicializa al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
